var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "block-editor ikas-get-member-info" },
    [
      !_vm.channel
        ? _c(
            "section",
            [
              _c("a-result", {
                attrs: { status: "warning", title: "Ikas API not connected" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "extra",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-items-center justify-content-center",
                            },
                            [
                              _c(
                                "SupsisButton",
                                {
                                  attrs: { primary: "", ghost: "" },
                                  on: { click: _vm.gotoIkas },
                                },
                                [_vm._v(" Connect to Ikas")]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1758316446
                ),
              }),
            ],
            1
          )
        : [
            _c("section", { staticClass: "active-connection" }, [
              _c(
                "div",
                { staticClass: "logos", attrs: { "data-small": "true" } },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v(" add "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "logo2" },
                    [_c("IkasIcon", { staticStyle: { width: "30px" } })],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _vm._m(1),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ikas-get-member-info-wrapper" }, [
              _c("div", { staticClass: "inputTitle" }, [_vm._v("Email")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-editor-wrapper" },
                [
                  _c("TiptapEditor", {
                    attrs: {
                      "show-attributes": true,
                      "max-character-count": 64,
                      "show-emoji": false,
                      placeholder: "Customer Email",
                      rows: 1,
                    },
                    model: {
                      value: _vm.clone.customerEmail,
                      callback: function ($$v) {
                        _vm.$set(_vm.clone, "customerEmail", $$v)
                      },
                      expression: "clone.customerEmail",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "inputTitle mt-5 mb-2 font-weight-bold" },
              [_vm._v(_vm._s(_vm.$t("chatbotv2.followingAttributesFilled")))]
            ),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "next-step-filled-items-wrapper" },
              _vm._l(_vm.nextStepFilledValue, function (attr) {
                return _c(
                  "div",
                  { key: attr, staticClass: "logos middle-section" },
                  [
                    _c("AttributeIconPreview", { attrs: { attribute: attr } }),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "ml-2" },
                      [_c("AttributeLabel", { attrs: { attribute: attr } })],
                      1
                    ),
                  ],
                  1
                )
              }),
              0
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo1" }, [
      _c("img", {
        staticClass: "custom-block-logo",
        attrs: { src: "/static/img/supsis-logo2.png" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "active-connection-text" }, [
      _c("div", [
        _c("span", [_vm._v("Connected with")]),
        _vm._v(" "),
        _c("b", [_vm._v("Ikas")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }